import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { AutoCompleteLabelValue } from "./AutoCompleteLabelValue";

import { FilterOrderTypes } from "../FilterTypeEnums";

export class AutoCompleteFilterOrderTypeLabelValue implements AutoCompleteLabelValue {
  __bfx_visibility_type: string;

  constructor(
    public type: FilterOrderTypes,
    public label: string,
    public value: string,
    public _findValue?: string,
  ) {}

  /**
   * filter acts on algo description
   * find acts on algo name
   */
  public get findValue(): string {
    if (this._findValue != null) {
      return this._findValue;
    }

    return this.value;
  }
}
